import React from "react"
import PropTypes from "prop-types"

import AvailabilityCard from "./AvailabilityCard"

const AvailabilityList = ({
  registradas,
  regions,
  farm,
  farmId,
  product,
  expanded,
  editing,
  isSaving,
  canEdit = true,
  onToggleExpanded,
  onStartEdit,
  onCancelEdit,
  onUpdate,
  onSaveZones,
}) => (
  <div className="av-anim">
    <div className="av-list-head">
      <h2>Disponibilidades registradas</h2>
      <span className="av-badge">{registradas.length}</span>
    </div>

    {registradas.length === 0 ? (
      <div className="av-empty">
        No hay disponibilidades registradas para esta categoría.
      </div>
    ) : (
      registradas.map(daily => (
        <AvailabilityCard
          key={daily.id}
          daily={daily}
          regions={regions}
          farm={farm}
          farmId={farmId}
          product={product}
          isExpanded={expanded === daily.id}
          isEditing={editing === daily.id}
          isSaving={isSaving}
          canEdit={canEdit}
          onToggle={() => onToggleExpanded(daily.id)}
          onStartEdit={() => onStartEdit(daily.id)}
          onCancelEdit={onCancelEdit}
          onUpdate={onUpdate}
          onSaveZones={onSaveZones}
        />
      ))
    )}
  </div>
)

AvailabilityList.propTypes = {
  registradas: PropTypes.array.isRequired,
  regions: PropTypes.array.isRequired,
  farm: PropTypes.object,
  farmId: PropTypes.number,
  product: PropTypes.object.isRequired,
  expanded: PropTypes.number,
  editing: PropTypes.number,
  isSaving: PropTypes.bool,
  // fuera de la ventana de captura las tarjetas se consultan pero no se editan
  canEdit: PropTypes.bool,
  onToggleExpanded: PropTypes.func.isRequired,
  onStartEdit: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onSaveZones: PropTypes.func,
}

export default AvailabilityList
